













































































































































































import { Component, Vue, Prop, Watch, Emit } from 'vue-property-decorator';

import { Mutation, Getter } from 'vuex-class';
import { cloneDeep } from 'lodash';
import { IToggleFilter, IFilterValue } from '~/types/gala-store';
import { IInventoryCollection } from '~/store/cms_content/types';
import {
  IGalaStoreFilterOptions,
  GalaStoreToggleFilterCategory,
  IStoreTokenPrice,
} from '~/types/gala-store';

@Component
export default class StoreFilters extends Vue {
  @Getter('inventoryIconForCollectionName', { namespace: 'cmsContent' })
  collectionIcons!: Record<string, IInventoryCollection | undefined>;
  @Prop(Object) readonly options!: IGalaStoreFilterOptions;
  @Prop(Array) readonly usdPricesInCents!: number[];
  @Prop(Object) readonly tokenPrice!: IStoreTokenPrice;
  @Prop(String) readonly selectedCurrency!: string;
  @Prop(Object) readonly appliedFilters!: IGalaStoreFilterOptions;
  @Prop(Boolean) isGamePage!: boolean;

  @Mutation toggleErrorSnackbar!: (payload?: boolean) => void;
  @Mutation updateSnackbarErrorText!: (args: any) => void;

  panel = [0, 1, 2, 3, 4];
  priceRange = [0, 0];
  maxShownItems = 10;
  gameSearch = '';
  showMaxCategories: string[] = [];

  get priceFilterMin() {
    return (
      this.usdPricesInCents[this.priceRange[0]] /
      this.tokenPrice.tokenPriceInCents
    );
  }

  get priceFilterMax() {
    return (
      this.usdPricesInCents[this.priceRange[1]] /
      this.tokenPrice.tokenPriceInCents
    );
  }

  get filterCategories() {
    const options = cloneDeep(this.options);
    if (this.hideGameFilters) {
      delete options.games;
    }

    if (
      (options.price &&
        this.usdPricesInCents[0] ===
          this.usdPricesInCents[this.usdPricesInCents.length - 1]) ||
      this.tokenPrice === null
    ) {
      delete options.price;
    }

    if (options.rebates && options.availability) {
      const rebateValuesWithPointer = options.rebates.values.map(v => {
        return { ...v, originalCategory: 'rebates' };
      });
      options.availability.values = [
        ...options.availability.values,
        ...rebateValuesWithPointer,
      ];
      delete options.rebates;
    }

    // If a game filter is applied, we only want to display 'type' (category) filters that are available for the game items displayed
    // We also want to display any type filters that are already selected by the user
    // Game details pages that display store items don't need this code run, since for game pages the correct type filters are being collected in the initial filter query
    if (
      !this.isGamePage &&
      this.appliedFilters?.games?.values &&
      options.type?.values
    ) {
      const appliedGameFilters = this.appliedFilters.games.values.map(value => {
        return value.name;
      });

      options.type.values = options.type.values.filter(value => {
        if (value.typeGames) {
          const sharedGames = value.typeGames.filter(game => {
            return appliedGameFilters.includes(game);
          });
          return sharedGames.length > 0 || value.selected;
        }

        return false;
      });
    }

    return Object.entries(options);
  }

  get hideGameFilters() {
    return this.$route?.name === 'games-name';
  }

  toggleShowMaxCategory(category: string) {
    const index = this.showMaxCategories.findIndex(cat => cat === category);
    if (index === -1) {
      this.showMaxCategories.push(category);
    } else {
      this.showMaxCategories.splice(index, 1);
    }
  }

  getIcon(gameName: string) {
    return (
      this.collectionIcons[gameName]?.inventoryImage ||
      require('@/assets/icons/icon_misc_circle.png')
    );
  }

  checkIfOpen(index: number) {
    return this.panel.includes(index);
  }

  getGames(values: IFilterValue[]) {
    if (!this.gameSearch) return values;
    return values.filter(value =>
      value.name.toLowerCase().includes(this.gameSearch.toLowerCase()),
    );
  }

  getPriceFormatString(price: string) {
    const highPrice = +price >= 1000000;
    let baseString = '0,0';

    if (this.selectedCurrency !== 'GALA' || highPrice) {
      baseString += '[.]0[00]';
    }
    if (highPrice) {
      baseString += ' a';
    }

    return baseString;
  }

  handleRangeChange(range: number[]) {
    // the range are the indices of values to pull from the prices array
    const [selectedMinIndex, selectedMaxIndex] = range;

    this.handleToggleFilterChange({
      type: GalaStoreToggleFilterCategory.price,
      name: 'minimum',
      selected: true,
      value: this.usdPricesInCents[selectedMinIndex],
    });

    this.handleToggleFilterChange({
      type: GalaStoreToggleFilterCategory.price,
      name: 'maximum',
      selected: true,
      value: this.usdPricesInCents[selectedMaxIndex],
    });
  }

  @Emit('toggle-filter-change')
  handleToggleFilterChange(update: {
    type: GalaStoreToggleFilterCategory;
    name: string;
    selected: boolean;
    value?: number | string;
  }) {
    return update;
  }

  @Watch('usdPricesInCents', { immediate: true })
  initializePriceRange(prices: number[]) {
    if (prices && prices.length) {
      this.priceRange = [0, prices.length - 1];
    }
  }

  @Watch('options.price', { deep: true, immediate: false })
  handlePriceRangeReset(priceFilters: IToggleFilter) {
    const [minFilter, maxFilter] = priceFilters.values;
    const updatedPriceRange = [...this.priceRange];

    if (minFilter && !minFilter.selected) {
      updatedPriceRange[0] = 0;
    }
    if (this.usdPricesInCents.length && maxFilter && !maxFilter.selected) {
      updatedPriceRange[1] = this.usdPricesInCents.length - 1;
    }

    this.priceRange = updatedPriceRange;
  }
}
